import { render, staticRenderFns } from "./teleHealth-details.vue?vue&type=template&id=03f6a78d&scoped=true&"
import script from "./teleHealth-details.vue?vue&type=script&lang=js&"
export * from "./teleHealth-details.vue?vue&type=script&lang=js&"
import style0 from "./teleHealth-details.vue?vue&type=style&index=0&id=03f6a78d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f6a78d",
  null
  
)

component.options.__file = "teleHealth-details.vue"
export default component.exports